import AuthFn, {AuthManage, navigationGuard} from './AuthFn'

export default AuthFn
export {AuthManage, navigationGuard}
